<template>
  <v-card outlined rounded="lg">
    <v-card-title class="font-weight-bold subtitle-1"
      >Crédito do cliente</v-card-title
    >
    <v-card-text>
      <v-row>
        <v-col xl="4" lg="4" md="4" cols="12">
          <v-list-item class="grey lighten-3 rounded-lg">
            <v-list-item-content>
              <v-list-item-subtitle>Limite de crédito</v-list-item-subtitle>
              <v-list-item-title class="font-weight-bold mt-1">{{
                formatarMoeda(perfil.credito.limite)
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col xl="4" lg="4" md="4" cols="12">
          <v-list-item class="grey lighten-3 rounded-lg">
            <v-list-item-content>
              <v-list-item-subtitle>Limite utilizado</v-list-item-subtitle>
              <v-list-item-title class="font-weight-bold mt-1">{{
                formatarMoeda(perfil.credito.limiteutilizado)
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col xl="4" lg="4" md="4" cols="12">
          <v-list-item class="grey lighten-3 rounded-lg">
            <v-list-item-content>
              <v-list-item-subtitle
                >Saldo Limite de Crédito</v-list-item-subtitle
              >
              <v-list-item-title
                :class="'font-weight-bold mt-1 ' + classSaldoLimiteCredito()"
                >{{
                  formatarMoeda(perfil.credito.limitesaldo)
                }}</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatMoeda } from "@/global";

export default {
  props: {
    perfil: Object,
  },
  methods: {
    formatarMoeda(value) {
      return formatMoeda(value);
    },
    classSaldoLimiteCredito() {
      if (this.perfil.credito.limitesaldo < 0) return "red--text";
      else if (this.perfil.credito.limitesaldo > 0) return "green--text";

      return "";
    },
  },
};
</script>

<style>
</style>